import { useState } from "react";
import QuantumSummaryTable from "./QuantumTable";

const DataTabs = ["Quantum", "Cost"];

export default function AnnualSummaryTable({
  refreshKey,
  setError,
  selectedScenarios,
}: {
  refreshKey: number;
  setError?: any;
  selectedScenarios: Array<{ scenario_id: number, scenario_number: number }>;
}) {
  const [activeTab, setActiveTab] = useState<string>(DataTabs[0]);
  const [selectedYears, setSelectedYears] = useState<any[]>([]);
  const [availableYears, setAvailableYears] = useState<any[]>([]);

  return (
    <div className="dash-card col-span-1 md:col-span-12 border border-[#718EBF1C] !bg-[#fff] !p-2 h-full min-h-0 w-full flex flex-col gap-4">
      <div className="flex-1 overflow-auto h-full">
        <QuantumSummaryTable
          refreshKey={refreshKey}
          setError={setError}
          selectedYears={selectedYears}
          setSelectedYears={setSelectedYears}
          setAvailableYears={setAvailableYears}
          selectedScenarios={selectedScenarios}
        />
      </div>
    </div>
  );
}